import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { CardContent, Collapse, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import toast from "react-hot-toast";
import * as htmlToImage from 'html-to-image';

import CustomDropDownToggle from "../../../common/CustomDropDownToggle";
import CustomActionButton from "../../../common/CustomActionButton";
import CustomButton from "../../../common/CustomButton";
import CustomSliderModalV2 from "../../../common/CustomSliderModalV2";
import CustomSelect from '../../../common/CustomSelect';

import { SendEmail } from "../../../redux/brg/actions";
import { delay, removeDuplicates } from "../../../utils";
import useSVG from "../../../hooks/useSVG";
import usePrompt from "../../../hooks/usePrompt";
import CustomModal from '../../../common/CustomModal';

function EmailContentV2(props) {

    const { patient, Brg, filtered = false, suggestedPrograms } = props;
    const emailTemplates = props?.EmailTemplate?.list;
    const [isOpen, setIsOpen] = useState(false);
    const [eventID, setEventID] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalReminder, setShowModalReminder] = useState(false);
    const [showModalType, setShowModalType] = useState("view");
    const [emailVersion, setEmailVersion] = useState("latest");
    const [displayFormat, setDisplayFormat] = useState("email");

    const [generatedEmails, setGeneratedEmails] = useState([]);
    const [htmlPreview, setHtmlPreview] = useState("");

    const [emailTemplate, setEmailTemplate] = useState(null);
    const [emailTemplateReminder, setEmailTemplateReminder] = useState(null);

    const [etOptions, setEtOptions] = useState([]);
    const [etOptionsReminder, setEtOptionsReminder] = useState([]);

    const [email, setEmail] = useState(null);

    const { UseProgramSVG } = useSVG();
    const { handleGenerateEmail, handleFilterEmail } = usePrompt();

    // const email = generatedEmails?.[0] || null;


    useEffect(() => {
        if (emailTemplates?.length > 0) {
            const defaultET = emailTemplates?.filter((et) => (et?.tag == "post-discharge" && et?.is_default == 1))?.[0]
            const defaultETReminder = emailTemplates?.filter((et) => (et?.tag == "post-discharge-reminder" && et?.is_default == 1))?.[0]
            setEmailTemplate(defaultET || null);
            setEmailTemplateReminder(defaultETReminder || null);

            const tempETO = [defaultET, ...emailTemplates.filter((et) => (et?.tag == "post-discharge" && et?.is_default == 0))];
            const tempETOR = [defaultETReminder, ...emailTemplates.filter((et) => (et?.tag == "post-discharge-reminder" && et?.is_default == 0))];
            setEtOptions(tempETO.map((et) => {
                return {
                    value: et?.id,
                    label: et?.name.toUpperCase(),
                }
            }));
            setEtOptionsReminder(tempETOR.map((et) => {
                return {
                    value: et?.id,
                    label: et?.name.toUpperCase(),
                }
            }));
        }

    }, [emailTemplates?.length]);

    useEffect(() => {

        if (patient?.generatedEmails.length > 0) {
            // let emails = patient?.generatedEmails?.filter((ge) => ge?.filtered == (filtered ? 1 : 0))
            let emails = patient?.generatedEmails;
            emails = emails.reverse();
            emails = removeDuplicates(emails, "id");

            setGeneratedEmails(emails);
            setEmail(emails?.[0]);
            props.setSelectedEmail(emails?.[0]);

        }

    }, [patient?.id, patient?.generatedEmails?.length]);

    useEffect(() => {
        props.setSelectedEmail(generatedEmails?.[emailVersion == "latest" ? 0 : 1] || null);
    }, [emailVersion]);

    const parseJSON = (content) => {

        let parsed = null;
        try {
            parsed = JSON.parse(content);
        } catch (error) {

            try {
                // let fixedJson = content.replace(/'/g, '"');
                let fixedJson = content.replace(/(\w+):/g, '"$1":');
                fixedJson = fixedJson.replace(/,\s*([\]}])/g, '$1');

                parsed = JSON.parse(fixedJson);
            } catch (error2) {
                parsed = null;
            }

        }

        return parsed;
    }

    const arrange = (emailContent) => {

        if (!emailContent) {
            return "ERROR PARSING EMAIL CONTENT";
        }

        const sp = emailContent?.["suggestions"] || emailContent?.["suggested_programs"];

        let content = "";
        content += `Subject: ${emailContent?.email_subject}\n\n`;
        content += `Preview Text: ${emailContent?.email_preview_text}\n\n`;
        content += `${emailContent?.headline_1}\n\n`;
        content += `${emailContent?.subtext_1}\n\n`;
        content += `${emailContent?.headline_2}\n\n`;
        content += `${emailContent?.subtext_2}\n\n`;
        content += `${emailContent?.headline_3}\n\n`;
        for (let i = 0; i < sp.length; i++) {
            content += `    ${sp[i]?.program_name}\n\n`;
            content += `    ${sp[i]?.program_description}\n\n`;
        }
        content += `${emailContent?.subtext_3}\n\n`;
        content += `${emailContent?.sign_off}\n\n`;

        return content;
    }

    const extractHTML = (reactElement) => {
        // Create a temporary container
        const container = document.createElement('div');

        // Render the React element into the container
        ReactDOM.render(reactElement, container);

        // Extract the inner HTML of the container
        const htmlString = container.innerHTML;

        // Cleanup: unmount the component and remove the container
        ReactDOM.unmountComponentAtNode(container);
        container.remove();

        return htmlString;
    }

    const arrangeHTMLContent = (htmlTemplate, patient, generatedEmail, eventID, sp) => {
        let htmlContent = htmlTemplate;
        const emailContent = parseJSON(email?.email_content);
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV);

        htmlContent = htmlContent.replaceAll("{{patient_name}}", (patient?.first_name));
        htmlContent = htmlContent.replaceAll("{{patient_email}}", (patient?.email || null));
        htmlContent = htmlContent.replaceAll("{{therapist_name}}", (patient?.therapist_name || null));
        htmlContent = htmlContent.replace("{{email_preview_text}}", emailContent?.email_preview_text);
        htmlContent = htmlContent.replace("{{headline_1}}", emailContent?.headline_1);
        htmlContent = htmlContent.replace("{{subtext_1}}", emailContent?.subtext_1);
        htmlContent = htmlContent.replace("{{headline_2}}", emailContent?.headline_2);
        htmlContent = htmlContent.replace("{{subtext_2}}", emailContent?.subtext_2);
        htmlContent = htmlContent.replace("{{headline_3}}", emailContent?.headline_3);

        let svg = null, gradient = null, src = null;
        for (let i = 0; i < emailContent?.suggested_programs.length; i++) {
            htmlContent = htmlContent.replace(`{{program_name${i + 1}}}`, emailContent?.suggested_programs[i]?.program_name);
            htmlContent = htmlContent.replace(`{{program_description${i + 1}}}`, emailContent?.suggested_programs[i]?.program_description);
            gradient = sp[i]?.gradient?.split("-")
            svg = <div className="program-img-wrapper" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})`, borderRadius: "50%", padding: "12px" }}>
                <img src={`${link}images/program-icons/${sp[i]?.svg?.split(".")[0]}.png`} alt="" />
            </div>
            if (htmlContent?.includes("program_image_src_")) {
                htmlContent = htmlContent.replace(`{{program_image_src_${i + 1}}}`, `${link}images/program-icons/${sp[i]?.svg?.split(".")[0]}.png`);
            } else {
                htmlContent = htmlContent.replace(`{{program_image_${i + 1}}}`, extractHTML(svg));
            }
        }

        htmlContent = htmlContent.replace("{{subtext_3}}", emailContent?.subtext_3);
        htmlContent = htmlContent.replace("{{sign_off}}", emailContent?.sign_off);
        htmlContent = htmlContent.replaceAll("{{signup_link}}", `${"https://indimoves.com/brg/"}?type=brgpatient&id=${generatedEmail?.id}&event_id=${eventID}&env=${process.env.REACT_APP_ENVIRONMENT}`);
        htmlContent = htmlContent.replace("{{signup_link2}}", `${"https://indimoves.com/brg/"}?type=brgpatient&id=${generatedEmail?.id}&event_id=${eventID}&env=${process.env.REACT_APP_ENVIRONMENT}`);

        htmlContent = htmlContent.replace("{{time_sent}}", moment().format("MMMM Do YYYY, h:mm:ss a"));

        return htmlContent;
    }

    const handlePreviewEmail = async (et = null) => {
        et = et;
        // const toastID = toast.loading("Generating Email Preview...");
        const tempEventID = new Date().getTime();

        setEventID(eID => tempEventID);
        setHtmlPreview(arrangeHTMLContent(et?.html_content, patient, email, tempEventID, suggestedPrograms));

        // toast.dismiss(toastID);
    }

    const handleSendEmail = async (et) => {
        const toastID = toast.loading("Sending Email...");
        // const genEmail = generatedEmails?.[emailVersion == "latest" ? 0 : 1] || null;
        let subject = et?.email_subject;
        if (et?.email_subject == "ai_generated") {
            let ec = parseJSON(email?.email_content);
            subject = ec?.email_subject
        } else {
            subject = subject.replace("{{patient_name}}", patient?.first_name);
        }

        const res = await props.SendEmail(patient, email, htmlPreview, subject, eventID, et);
        if (res) {
            toast.success("Email Sent Successfully", {
                id: toastID,
            });
            delay(() => {
                setShowModal(false);
            }, 1500)
        } else {
            toast.error("Failed to Send Email", {
                id: toastID,
            });
        }
    }

    // try {
    // } catch (error) {
    //     try {
    //         let fixedJson = email?.email_content.replace(/'/g, '"');
    //         fixedJson = fixedJson.replace(/(\w+):/g, '"$1":');
    //         fixedJson = fixedJson.replace(/,\s*([\]}])/g, '$1');
    //         parsedEmail = arrange(JSON.parse(fixedJson));
    //     } catch (error) {
    //         parsedEmail = "ERROR PARSING EMAIL CONTENT";
    //     }
    // }

    let parsedEmail = arrange(parseJSON(email?.email_content));




    return (
        <div className="brg-pp brg-pp-email-prompt" id="email-content-v2">
            <h5>
                Email Content {email?.filtered == 1 ? <em>{`(filtered)`}</em> : <em>{`(original)`}</em>}
            </h5>
            <div id="ec-v2-pre-wrapper">
                <div id="ec-v2-pre-label">
                    <Tooltip title="Preview Email" onClick={() => {
                        handlePreviewEmail(emailTemplate);
                        setShowModalType("view");
                        setShowModal(true);
                    }}>
                        <IconButton>
                            <VisibilityIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <pre onInput={(e) => {
                }}>
                    {email ? parsedEmail : "NONE"}
                </pre>
            </div>
            <div id="ec-v2-actions">
                <CustomButton isPrimary={false} onClick={async () => {
                    const toastID = toast.loading("Generating email...");
                    handleGenerateEmail({
                        ...patient,
                        sp: suggestedPrograms,
                    }, props?.Brg?.emailPrompt?.text, toastID);

                }}>
                    Generate Email
                </CustomButton>

                <CustomButton isPrimary={false} onClick={async () => {
                    const toastID = toast.loading("Generating filtered email...");
                    // const tp = await savePrompt(false);
                    handleFilterEmail({
                        ...patient,
                        sp: suggestedPrograms,
                    }, props?.Brg?.emailFilterPrompt?.text, email, toastID);
                }}>
                    Filter Email
                </CustomButton>

                <CustomButton onClick={async () => {
                    handlePreviewEmail(emailTemplate);
                    setShowModalType("send");
                    setShowModal(true);
                    // const toastID = toast.loading("Generating email...");
                    // const tp = await savePrompt(false);
                    // handleGenerateEmail(tp, toastID);
                }}>
                    Send Email
                </CustomButton>


                <CustomButton onClick={async () => {
                    handlePreviewEmail(emailTemplateReminder);
                    setShowModalReminder(true);
                }}>
                    Send Reminder
                </CustomButton>

            </div>

            <CustomModal
                size="m"
                toggle={setShowModal}
                show={showModal}
                title=""
                body={(
                    <>
                        <div id="ep-cs-template">
                            <CustomSelect placeholder={"Template"} options={etOptions} onChange={(e) => {
                                const et = emailTemplates?.filter((et) => et?.id == e.target.value)?.[0];
                                setEmailTemplate(et);
                                handlePreviewEmail(et);
                            }} />
                        </div>

                        <div className="preview" dangerouslySetInnerHTML={{ __html: htmlPreview }} />
                        {
                            showModalType == "send" && <div className="flex-r pt-5 pb-5">
                                <CustomActionButton disabled={!email?.created_at} action={() => {
                                    handleSendEmail(emailTemplate);
                                }}>
                                    SEND EMAIL
                                </CustomActionButton>
                            </div>
                        }
                    </>
                )}
            />

            <CustomModal
                size="m"
                toggle={setShowModalReminder}
                show={showModalReminder}
                title=""
                body={(
                    <>
                        <div id="ep-cs-template">
                            <CustomSelect placeholder={"Template"} options={etOptionsReminder} onChange={(e) => {
                                const et = emailTemplates?.filter((et) => et?.id == e.target.value)?.[0];
                                setEmailTemplateReminder(et);
                                handlePreviewEmail(et);
                            }} />
                        </div>

                        <div className="preview" dangerouslySetInnerHTML={{ __html: htmlPreview }} />
                        {
                            showModalType == "send" && <div className="flex-r pt-5 pb-5">
                                <CustomActionButton disabled={!email?.created_at} action={() => {
                                    handleSendEmail(emailTemplateReminder);
                                }}>
                                    SEND REMINDER EMAIL
                                </CustomActionButton>
                            </div>
                        }
                    </>
                )}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    Brg: state.Brg,
    EmailTemplate: state.EmailTemplate,
})

export default connect(mapStateToProps, {
    SendEmail,
})(EmailContentV2);
